import "components/jiffy/home/product_sections/product_sections";
import initHeroCard from "components/jiffy/home/hero_card/hero_card";
import deliveryDateFormClass from "common/utils/delivery-date/delivery-date-form-class";
import initHeroSlider from "components/jiffy/home/slider/slider";
import initHeroCardsScroll from "components/jiffy/home/hero_cards/hero_cards";

document.addEventListener("DOMContentLoaded", () => {
  deliveryDateFormClass().init();
  initHeroSlider();
  initHeroCard();
  initHeroCardsScroll();
});
